import { createSmsTemplate } from './createSmsTemplate';
import { fetchSmsTemplates } from './fetchSmsTemplates';
import { generateSmsExample } from './generateSmsExample';
import { generateDriverAcceptedSmsExample } from './generateDriverAcceptedSmsExample';
import { getSmsTemplateList } from './getSmsTemplateList';
import { getSmsTemplateRecipientList } from './getSmsTemplateRecipientList';
import { getSmsTemplateTopicList } from './getSmsTemplateTopicList';
import { updateSmsTemplate } from './updateSmsTemplate';

export const smsTemplateService = {
  createSmsTemplate,
  fetchSmsTemplates,
  generateSmsExample,
  generateDriverAcceptedSmsExample,
  getSmsTemplateList,
  getSmsTemplateRecipientList,
  getSmsTemplateTopicList,
  updateSmsTemplate,
};
